module.exports = __webpack_public_path__ + "media/click.f4ed7d5d.mp3";